module.exports = __webpack_public_path__ + "static/mobilenav-closeforward-dont-484438c45701529484298de1a5ed4048.png";